export enum GroupPageTabEnum {
  ENDPOINTS,
  HEADERS,
  PARAMETERS,
}
